import React, { useContext, useEffect, useState } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
export default function UI_Horizontal_Tabs({
    id,
    Selectors,
    Components,
    UIDs,
    Selected,
    Clickable,
    SelectorsOnly,
    onChange,
    NoStretch,
    Presentation
}) {
    const UI = useContext(Context_UI);
    const [ActiveTab, ActiveTab_Set] = useState(null);

    useEffect(() => {
        if (Selected) {
            ActiveTab_Set(Selected);
        }
    }, []);
    
    useEffect(() => {
        if (Selected && Selected !== ActiveTab) {
            ActiveTab_Set(Selected);
        }
    }, [Selected]);
    const Switch_Tab = (Index) => {
        var ID = "";
        if (!UIDs) {
            ID = `Tab_${Index}`;
        } else {
            ID = `Tab_${UIDs[Index]}`;
        }
        ActiveTab_Set(ID);
        if (onChange) {
            onChange(ID)
        }
        UI.Emit("Tabs_Horizontal_Switched", {
            ID: id,
            Tab_Active: ID
        });
    }
    
    const Icon_Render = (Icon) => {
        if (!Icon) return null;

        if (typeof Icon === "string") {
            return (
                <img
                    className="General_Button_Icon"
                    src={Icon}
                    draggable="false"
                    loading="lazy"
                    alt=""
                />
            );
        }

        if (typeof Icon === "function" || typeof Icon === "object") {
            if (React.isValidElement(Icon)) {
                return Icon;
            }
        }

        return null;
    };
    return (
        <>
            {!UIDs ? 
                <div className="Tabs_Horizontal" id={id} State={SelectorsOnly ? "NoMargins" : undefined} Presentation={Presentation ? Presentation : undefined}>
                    <div className="Tabs_Horizontal_Selector"
                        Clickability={Clickable == true || Clickable == null ? "Enabled" : "Disabled_NoFade"}
                    >
                        {Selectors?.map((Item, index) => (
                            <button className="Tabs_Horizontal_Selector_Item" key={index} onClick={() => Switch_Tab(index)} State={ActiveTab == `Tab_${index}` ? "Active" : "Inactive"} 
                                NoStretch={NoStretch ? "NoStretch" : undefined}
                            >
                                {Item.Icon ?
                                    <>
                                        {Icon_Render(Item.Icon)}
                                    </>
                                    // <img src={Item.Icon} className="Tabs_Horizontal_Selector_Item_Icon" draggable="false" loading="lazy" />
                                    :
                                    ""
                                }
                                <p className="Tabs_Horizontal_Selector_Item_Text">
                                    {Item.Text}
                                </p>
                                <div className="Tabs_Horizontal_Selector_Item_Background"></div>
                                <div className="Tabs_Horizontal_Selector_Item_Pill"></div>
                            </button>
                        ))}
                    </div>
                    <div className="Tabs_Horizontal_Children">
                        {Components?.map((Item, index) => (
                            <>
                                {ActiveTab == `Tab_${index}` ?
                                    <div className="Tabs_Horizontal_Child" key={index}>
                                        {Item}
                                    </div>
                                    :
                                    ""
                                }
                            </>
                        ))}
                    </div>
                </div>
                :
                <div className="Tabs_Horizontal" id={id} State={SelectorsOnly ? "NoMargins" : undefined} Presentation={Presentation ? Presentation : undefined}>
                    <div className="Tabs_Horizontal_Selector" Clickability={Clickable == true || Clickable == null ? "Enabled" : "Disabled"}>
                        {Selectors?.map((Item, index) => (
                            <button className="Tabs_Horizontal_Selector_Item" key={index} onClick={() => Switch_Tab(index)} State={ActiveTab == `Tab_${UIDs[index]}` ? "Active" : "Inactive"}
                                NoStretch={NoStretch ? "NoStretch" : undefined}
                            >
                                {Item.Icon ?
                                    <>
                                        {Icon_Render(Item.Icon)}
                                    </>
                                    // <img src={Item.Icon} className="Tabs_Horizontal_Selector_Item_Icon" draggable="false" loading="lazy" />
                                    :
                                    ""
                                }
                                <p className="Tabs_Horizontal_Selector_Item_Text">
                                    {Item.Text}
                                </p>
                                <div className="Tabs_Horizontal_Selector_Item_Background"></div>
                                <div className="Tabs_Horizontal_Selector_Item_Pill"></div>
                            </button>
                        ))}
                    </div>
                    <div className="Tabs_Horizontal_Children">
                        {Components?.map((Item, index) => (
                            <>
                                {ActiveTab == `Tab_${UIDs[index]}` ?
                                    <div className="Tabs_Horizontal_Child" key={index}>
                                        {Item}
                                    </div>
                                    :
                                    ""
                                }
                            </>
                        ))}
                    </div>
                </div>
            }
            
        </>

    )
}

